import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userMobileNumber: "",
};

export const userNumber = createSlice({
  name: "number",
  initialState,
  reducers: {
    setUserMobileNumber: (state, action) => {
      state.userMobileNumber = action.payload;
    },
  },
});
export const { setUserMobileNumber } = userNumber.actions;
export default userNumber.reducer;
